module.exports = __webpack_public_path__ + "img/cxTrends-6.633d079a.png";